export default "__VITE_ASSET__DAqcjEz___"